/* DSL Wishlist — localStorage product-id set */
(function(){
  var KEY = "dsl_wishlist";
  function get(){ try { return new Set(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch(e){ return new Set(); } }
  function set(s){ try { localStorage.setItem(KEY, JSON.stringify([...s])); } catch(e){} }
  function toggle(id){
    var s = get(); var added = !s.has(id);
    if (added) s.add(id); else s.delete(id);
    set(s);
    if (window.DSL_AB) window.DSL_AB.track("wishlist_toggle", {id: id, added: added});
    document.dispatchEvent(new CustomEvent("dsl:wishlist:change", {detail: {id: id, added: added, size: s.size}}));
    return added;
  }
  function has(id){ return get().has(id); }
  function applyState(){
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function(b){
      var id = b.dataset.wishlistToggle;
      b.setAttribute("aria-pressed", has(id) ? "true" : "false");
      b.classList.toggle("is-saved", has(id));
    });
  }
  document.addEventListener("click", function(e){
    var b = e.target.closest("[data-wishlist-toggle]");
    if (!b) return;
    e.preventDefault();
    toggle(b.dataset.wishlistToggle);
    applyState();
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", applyState);
  else applyState();
  window.DSL_WISHLIST = {get: get, has: has, toggle: toggle, applyState: applyState};
})();